import localizeCurrency from "@helpers/localizeCurrency"
import { PaymentIntent } from "@stripe/stripe-js"
import { Trans, useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Plan } from "src/types"

interface TermsCheckboxProps {
  fullPrice: number
  isTermsAccepted: boolean
  paymentIntent: PaymentIntent | undefined
  plan: Plan
  setIsTermsAccepted: (isTermsAccepted: boolean) => void
}

export default function TermsCheckbox({
  fullPrice,
  isTermsAccepted,
  paymentIntent,
  plan,
  setIsTermsAccepted,
}: TermsCheckboxProps) {
  const { t } = useTranslation()

  if (!paymentIntent) return null

  return (
    <div className="flex gap-2">
      <input
        checked={isTermsAccepted}
        className="outline-hidden focus:outline-hidden mt-1 rounded-sm focus:ring-0 focus:ring-offset-0"
        id="terms-checkbox"
        onChange={(event) => setIsTermsAccepted(event.target.checked)}
        type="checkbox"
      />

      <label
        className="cursor-pointer text-xs leading-relaxed"
        htmlFor="terms-checkbox"
      >
        {paymentIntent &&
          (plan === "weekly"
            ? t("pages.checkout.payment.termsCheckboxLabelWeekly", {
                price: localizeCurrency({
                  amountInCents: fullPrice,
                  currency: paymentIntent.currency,
                }),
              })
            : t("pages.checkout.payment.termsCheckboxLabelYearly", {
                price: localizeCurrency({
                  amountInCents: fullPrice,
                  currency: paymentIntent.currency,
                }),
              }))}{" "}
        <Trans
          components={{
            termsAndConditionsLink: (
              <Link
                className="underline"
                target="_blank"
                to="https://www.perfectday.ai/terms.html"
              />
            ),
            privacyPolicyLink: (
              <Link
                className="underline"
                target="_blank"
                to="https://www.perfectday.ai/privacy.html"
              />
            ),
          }}
          i18nKey="pages.checkout.payment.termsCheckboxLegalLinks"
        />
      </label>
    </div>
  )
}
